import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

import ChangeMonitoringStatusCell from '../ChangeMonitoringStatusCell';

interface IColumnProps {
	openErrorMessageModal: () => void;
}

export const getColumns = ({ openErrorMessageModal }: IColumnProps) => ([
	{
		header: 'n',
		accessorKey: 'n',
		cell: ({ row: { index } }: CellContext<any, any>) => {
			return <AdaptiveTableCell text={(index + 1).toString()} />;
		},
	},
	{
		header: 'Created',
		accessorKey: 'createdAtText',
		cell: ({ getValue }: CellContext<any, any>) => {
			return <AdaptiveTableCell text={getValue()} />;
		},
	},
	{
		header: 'From Status',
		accessorKey: 'fromStatus',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return (value && (
					<ChangeMonitoringStatusCell
						openErrorMessageModal={openErrorMessageModal}
						status={value}
					/>)
			);
		},
	},
	{
		header: 'To Status',
		accessorKey: 'toStatus',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return (value && (
					<ChangeMonitoringStatusCell
						openErrorMessageModal={openErrorMessageModal}
						status={value}
					/>)
			);
		},
	},
	{
		header: 'User',
		accessorKey: 'userName',
		cell: ({ getValue }: CellContext<any, any>) => {
			return <AdaptiveTableCell text={getValue()} />;
		},
	},
]);
